import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost, type PostValue } from './client'

export interface ScheduleDevice {
  ID: number
  Denumire: string
}

export interface SchedulePackage {
  ID: number
  Name: string
}

export interface ScheduleFormPage {
  devices: ScheduleDevice[]
  chosen: number[]
  locked: boolean
  packages: SchedulePackage[]
  company_id: number
  recurrences: Record<string, string>
  /** Ce se intampla cu restartul, din politica firmei (Settings > Softsee > Restarts). */
  restart?: { with_deadline: string; without_deadline: string; older_agents: string; summary: string }
}

export interface WriteStatus {
  status: string
  message?: string
  id?: number
}

export interface InstalledDevice {
  ID: number
  version: string
  uninstallable: number
  deviceId: number
  Tip: number
  Denumire: string
  Nume?: string | null
  Prenume?: string | null
}

export interface UninstallFormPage {
  application: number
  devices: InstalledDevice[]
}

export interface UpdateKit {
  ID: number
  type: string
  version: string
  name?: string
}

export interface UpdateFormPage {
  application: number
  details: Record<string, unknown>
  devices: InstalledDevice[]
  kit: UpdateKit | null
}

export function scheduleFormQuery(chosen: number[], onlyDevice = 0) {
  return queryOptions({
    queryKey: ['softsee', 'scheduleInstallForm', chosen, onlyDevice],
    queryFn: () =>
      apiPost<ScheduleFormPage>('/softsee/scheduleInstallForm', {
        only_device: onlyDevice,
        device: chosen,
      }),
  })
}

export function uninstallFormQuery(id: number) {
  return queryOptions({
    queryKey: ['softsee', 'uninstallApplicationDevices', id],
    queryFn: () => apiGet<UninstallFormPage>(`/softsee/uninstallApplicationDevices/${id}`),
  })
}

export function updateFormQuery(id: number) {
  return queryOptions({
    queryKey: ['softsee', 'updateApplicationDevices', id],
    queryFn: () => apiGet<UpdateFormPage>(`/softsee/updateApplicationDevices/${id}`),
  })
}

export function saveScheduledInstall(fields: Record<string, PostValue>) {
  return apiPost<WriteStatus>('/softsee/saveScheduledInstall', fields)
}

export function stopScheduledInstall(id: number) {
  return apiPost<WriteStatus>('/softsee/stopScheduledInstall', { id })
}

export function installPackage(fields: Record<string, PostValue>) {
  return apiPost<WriteStatus>('/softsee/installPackage', fields)
}

export function updateAllFromKit(fields: Record<string, PostValue>) {
  return apiPost<WriteStatus>('/softsee/updateAllFromKit', fields)
}
